import React from "react";

function Credentials(props){

    return (
        /*Credentials*/

    <div id="credentials" className="section ">
    <div className="">
    <h2 className="fs-1">Why should you hire me?</h2>
    <p>My passion for chemistry is infectious and I make praise the first part of any response. I put your child at the centre of 
      their learning and sensitively seek out and eliminate their weaknesses, while emphasising their existing strengths. I find out 
      the things they do for fun and pitch new learning in those familiar contexts. </p>
    
      <div className="row m-auto d-flex justify-content-center" >
        <div className="col-md-5">
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/burnt-orange-test-tube.png"></img>
            </div>
            Batchelor’s degree in chemistry, Sheffield
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/orange-test-tube.png"></img>
            </div>
            Qualified teacher status
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/pink-test-tube.png"></img>
            </div>
            PGCE, Cambridge
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/red-test-tube.png"></img>
            </div>
            Masters of Education in Science Learning, Cambridge
          </li>
          
        </div>
        <div className="col-md-5">
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/burnt-orange-test-tube.png"></img>
            </div>
            Ten years classroom teaching experience
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/orange-test-tube.png"></img>
            </div>
            Four years experience tutoring full time
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/pink-test-tube.png"></img>
            </div>
            Published science author
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/red-test-tube.png"></img>
            </div>
            Examiner of A-level chemistry papers for OCR
          </li>
          <li className="d-flex">
            <div className="test-tube-icon-container" >
              <img className="test-tube-icon " alt="" src="images/test-tube-icons/burnt-orange-test-tube.png"></img>
            </div>
            DBS Certificate
          </li>
        </div>          
      </div>        
    </div>
  </div>
    )
}

export default Credentials;